import api from '../../utils/ApiConfig';

export const getClientDigests = async (periode) => {
  const qs = periode ? `?periode=${encodeURIComponent(periode)}` : '';
  const response = await api.get(`/bo/digests${qs}`);
  return response.data;
};

/**
 * Récupère le HTML du récap via le client API, et non par l'URL directe dans
 * une iframe : une iframe ne peut pas porter l'en-tête Authorization, et
 * l'endpoint est protégé par jwt.verify + admin:5. Le HTML est ensuite injecté
 * dans l'iframe par srcDoc.
 */
export const getClientDigestPreview = async (id) => {
  const response = await api.get(`/bo/digests/${id}/preview`, { responseType: 'text' });
  return response.data;
};

export const sendClientDigest = async (id) => {
  const response = await api.post(`/bo/digests/${id}/send`);
  return response.data;
};
